import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getDatabase, ref, get } from 'firebase/database';
import { useAuth } from '../firebase';
import { getAuth, signOut } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';

const TrainerAccount = () => {
  const { currentUser } = useAuth();
  const [trainerData, setTrainerData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTrainerData = async () => {
      try {
        if (currentUser && currentUser.email) {
          const db = getDatabase();
          const trainersRef = ref(db, 'trainers');
          const snapshot = await get(trainersRef);

          if (snapshot.exists()) {
            const trainers = Object.values(snapshot.val());
            const trainer = trainers.find((trainer) => trainer.email === currentUser.email);

            if (trainer) {
              setTrainerData(trainer);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchTrainerData();
  }, [currentUser]);

  const handleSignOut = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);

      navigate('/login'); // Redirect to login page after sign out
    } catch (error) {
      console.log(error);
    }
  };

  if (!trainerData) {
    return (
      <Typography variant="h3" textAlign={'center'} alignContent={'center'} mt={20} mb={30} border={'2px solid'} borderRadius={'70px'} ml={40} mr={40}>
        <br/>Seems like you've signed out or <br/><br/>haven't logged in to your account.<br/><br/><br/><br/>
        <Link to={'/login'}>Click here to Login</Link><br/>
      </Typography>
    );
  }

  return (
    <Box sx={{ p: '20px' }}>
      <Box>
        <Typography variant='h3' mb={6} mt={10} backgroundColor='#ccdbee' textAlign={'center'} borderRadius={'20px'} p={'20px'} >
          Trainer Account Details
          <Button variant="contained" onClick={handleSignOut} sx={{  mb:1.5,ml:20,textAlign:'right',alignContent:'flex-end'}}>
            Sign Out
          </Button>
        </Typography>
      </Box>

      {trainerData && (
        <Box mt={4} mx="auto" maxWidth={600}>
          <TableContainer>
            <Table sx={{ minWidth: 400 }} border='2px solid'>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '30px', backgroundColor: '#94b1e6' }}>
                    <strong>Field</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '30px', backgroundColor: '#94b1e6' }}>
                    <strong>Value</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Name</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Email</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Age</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.age}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Experience</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.experience}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Knowledge</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.knowledge}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Working Hours</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.hours}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Monthly Charge</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.monthlyCharge}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>
                    <strong>Contact Information</strong>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: '20px', backgroundColor: '#f9e076' }}>{trainerData.contactNumber}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};

export default TrainerAccount;
